import { getRange } from './utils';

export const BLOCK_MAX_DENSITY = 3
export const BLOCK_SCORE = 1;

const getRandomBlock = () => {
    //return Math.floor(Math.random() * BLOCK_MAX_DENSITY)
    return 0
}


const getBlocks = (rows, columns) =>
    getRange(rows).map(() => getRange(columns).map(getRandomBlock))


export const LEVELS = [
    {
        lives: 5,
        paddleWidth: 2.4,
        speed: 1.4,
        blocks: getBlocks(3, 7)
    },
    {
        lives: 4,
        paddleWidth: 2.3,
        speed: 1.6,
        blocks: getBlocks(5, 7)
    },
    {
        lives: 3,
        paddleWidth: 2.1,
        speed: 1.8,
        blocks: getBlocks(6, 8)
    },
    {
        lives: 3,
        paddleWidth: 1.8,
        speed: 2.0,
        blocks: getBlocks(7, 8)
    },
    {
        lives: 3,
        paddleWidth: 1.5,
        speed: 2.2,
        blocks: getBlocks(8, 9)
    },
]
